// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-scroll {
  background-color: #2c4095;
  border-bottom: 2px solid #fa6164;
  color: white !important;
}
  
.react-time-picker__wrapper {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".active-scroll {\n  background-color: #2c4095;\n  border-bottom: 2px solid #fa6164;\n  color: white !important;\n}\n  \n.react-time-picker__wrapper {\n  border: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
